module.exports = __webpack_public_path__ + "static/media/ic-regulier.d0651fd4.svg";